import BaseBusinessAPI from '../portal/baseBusinessAPI'

class EnrollmentAPI extends BaseBusinessAPI {
  controllerName = 'enrollmentProfiles';
}

export default new EnrollmentAPI()
